import { useMemo } from 'react';

import { useAuth } from 'context/AuthContext';
import { useMenuData } from 'context/MenuDataContext';
import { useCanRenouncePreferences } from 'hooks/useCanRenouncePreferences';
import { getNamedDates } from 'services/utils';
import { canAccessExperienceCatalog } from 'utils/experience-catalog';

import { NavEntry, buildMenuEntries } from './menu-items';

export function useMenuEntries(): NavEntry[] {
  const { user, userInfo, realCycle, cycleSelected } = useAuth();
  const { showCatalog } = useMenuData();
  const canRenouncePreferences = useCanRenouncePreferences();

  const selectedCycle = useMemo(
    () => realCycle?.find((cycle: any) => cycle._id === cycleSelected?._id),
    [realCycle, cycleSelected],
  );

  return useMemo(
    () =>
      buildMenuEntries({
        isRede: !!user?.extra?.rede,
        isManager: !!userInfo?.is_manager,
        canAccessCatalog: canAccessExperienceCatalog(userInfo),
        showCatalog,
        rewardsLabel:
          selectedCycle && selectedCycle.date_end > getNamedDates().ciclo_1S2025 ? 'Extrato de premiação' : 'Pontos Livelo',
        canRenouncePreferences,
      }),
    [user, userInfo, selectedCycle, canRenouncePreferences, showCatalog],
  );
}
